import React from "react";

import type { StatusValue } from "../../../application/domain/proc-management";
import { ProcedureStatusTag } from "./procedure-status-tag";

type Props = { text: string | JSX.Element; withStatus?: StatusValue };

export const Title: React.FC<Props> = ({ text, withStatus }) => {
  return (
    <div className="columns is-vcentered">
      <div className="column has-text-left">
        <h1 className="title">{text}</h1>
        {!!withStatus && <ProcedureStatusTag status={withStatus} />}
      </div>
    </div>
  );
};

export default Title;
